import ConversationHeader from "components/ConversationHeader";
import UserInfo from "components/UserInfo";
import React from "react";
import { CABLE_BASE_URL } from "utils/constants";
import { findParticipant, participantName } from "utils/participants";

const addAbsolutePathToImage = (imageUrl) => {
  if (!imageUrl) return null;
  return imageUrl.startsWith("http") ? imageUrl : `//${imageUrl}`;
};

const getParticpantId = (conversation) => {
  const id = conversation?.participations?.find((element) => element.participant_type === "user")?.participant?.id;
  return id;
};

const chatConfigs = {
  enabled: true,
  isObserver: true,
  authorizedRoles: ["super_admin", "observer"],
  chatOpsWeb: {
    conversationName: (conversation) => {
      const { participations } = conversation;
      if (!participations?.length) return "Chat";
      const names = [participantName(participations, "user"), participantName(participations, "coach")].filter(Boolean);
      return names.length ? names.join(" • ") : "Chat";
    },
    conversationNameInChat: (conversation) => <ConversationHeader conversation={conversation} />,
    resolveConversationTargetImage: (conversation) => {
      return addAbsolutePathToImage(findParticipant(conversation.participations, "user")?.image_url);
    },
    getIdFromConversation: (conversation) => getParticpantId(conversation),
    UserInfoModalContent: UserInfo,
    isBroadcastEnabled: false,
    theme: {
      primaryColor: "rgb(0, 46, 58)",
      background: "https://res.cloudinary.com/thewebops/image/upload/v1600629686/background_jvg2z3.jpg",
      // Roboto has no Arabic letters, so English stays in Roboto and Arabic falls through to Tajawal.
      fontFamily: "'Roboto', 'Tajawal', sans-serif",
    },
    orientationPriority: "User",
  },
  chatopsActionCable: {
    apiEndpoints: {
      fetchMessages: {
        endpoint: (id) => {
          return `/conversations/${id}`;
        },
        method: "GET",
      },
      fetchContact: {
        endpoint: (id) => `users/${id}/info`,
        method: "get",
      },
    },
    conversationSearchParamName: "username",
    // The admin chat is an observer, so it tells the API what an admin read only with this on: when they
    // open a conversation, and when a new message arrives in the open one. It calls
    // PATCH /admin/conversations/:id (nutivate-api#150), the package's default updateLastAppearance address.
    observerMarksRead: true,
  },
  senderType: "Admin",
  nameSpace: "admin",
  cableURL: CABLE_BASE_URL,
  // Signs in with a single-use ticket (POST /admin/chat_ticket), not the token and email in the
  // address, where a "+" in the email turned into a space and the chat could not connect.
  cableTicket: true,
  filters: [
    {
      entity: "coach",
      label: "Coach",
      name: "coach_id",
      type: "select",
      hideTypography: true,
      placeholder: "Coach",
      selectConfig: {
        isSearchable: false,
        optionsType: "dynamic",
        optionsEntity: {
          name: "coach",
          labelField: "name",
          valueField: "id",
        },
      },
    },
  ],
};

export default chatConfigs;
